/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Sim_SrInputs */

const es_landing_sim_sr = /** @type {(inputs: Landing_Sim_SrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir simulación ampliada`)
};

const gl_landing_sim_sr = /** @type {(inputs: Landing_Sim_SrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir simulación ampliada`)
};

const en_landing_sim_sr = /** @type {(inputs: Landing_Sim_SrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open enlarged simulation`)
};

/**
* | output |
* | --- |
* | "Open enlarged simulation" |
*
* @param {Landing_Sim_SrInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_sim_sr = /** @type {((inputs?: Landing_Sim_SrInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Sim_SrInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_sim_sr(inputs)
	if (locale === "en") return en_landing_sim_sr(inputs)
	return es_landing_sim_sr(inputs)
});